module.exports = __webpack_public_path__ + "static/img/footercode.8583500.png";